import React, { useState, useEffect } from "react";
import { Form, Input, Modal, Button, Row, Col, Select, AutoComplete } from "antd";
import { doDelete, doPatch, doPost } from "../../../../API/apis";
import {
  validatePrice,
  validateServiceName,
} from "../../../../utils/validator";
import { useStateServicesContext } from "../../../../contexts/ServicesContext";
import Notification from "../../../../components/Notification/Notification";
import showConfirmModal from "../../../../components/ModalConfirm/ModalConfirm";
import { useSearchServices } from "../../../../API/apiUtils";
import BasicButton from "../../../../components/BasicButton/BasicButton";
import { useStateGlobalContext } from "../../../../contexts/GlobalContext";
import { getServiceListColumns } from "../../../../components/TableColumns/TableColumns";
import CustomTable from "../../../../components/CustomTable/CustomTable";
const { Option } = Select;

const ServiceList = () => {
  const [form] = Form.useForm();
  const [isModal, setIsModal] = useState(false);
  const [editService, setEditService] = useState(null);
  const {submitLoading, setSubmitLoading, profile} = useStateGlobalContext()
  const { options: serviceTypeOptions, handleSearchServices } =
  useSearchServices();
  const role = profile && profile?.user_info[0]?.role;

  const [loading, setLoading] = useState(false);
  const {
    group,
    getGroup,
    serviceType,
    getServiceType,
    services,
    getServices,
  } = useStateServicesContext();

 

  const handleEdit = (record) => {
    setEditService(record);
    form.setFieldsValue({
      service_name: record.service_names,
      service_type: record.service_type,
      service_group: record.service_group_name,
      service_price: record.price,
    });
    setIsModal(true);
  };
  const openModal = () => {
    setIsModal(true);
  };

  const handleSubmit = async (values) => {
    setSubmitLoading(true)
    try {
      const data = {
        service_names: values.service_name,
        service_type: values.service_type || "",
        service_group_name: values.service_group || "",
        price: values.service_price || 0,
      };

      let response;
      if (editService) {
        const updatedData = {};

        if (editService.service_names !== values.service_name) {
          updatedData.service_names = values.service_name;
        }
        if (editService.service_type !== values.service_type) {
          updatedData.service_type = values.service_type;
        }
        if (editService.service_group_name !== values.service_group) {
          updatedData.service_group_name = values.service_group;
        }
        if (editService.price !== values.service_price) {
          updatedData.price = values.service_price;
        }

        if (Object.keys(updatedData).length === 0) {
          Notification.error("No Changes Detected");
          return;
        }
        response = await doPatch(
          `/services/update/${editService.id}/`,
          updatedData
        );
      } else {
        response = await doPost(`/services/add/`, data);
      }

      if (response.status === 200 || response.status === 201) {
        const successMessage = editService
          ? "Service Updated Successfully"
          : "Service Added Successfully";

        Notification.success(successMessage);
        getServices();
        handleCancel();
      } else {
        Notification.error("Service Name Already Exists");
      }
    } catch (error) {
      Notification.error("Service Name Already Exists");
    } finally{
      setSubmitLoading(false)
    }
  };

  const handleCancel = () => {
    setIsModal(false);
    setEditService(null);
    form.resetFields();
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await doDelete(`/services/delete/${id}/`);
      if (response.status === 200) {
        Notification.success("Service Deleted Successfully");
        getServices();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const showDeleteConfirm = (id) => {
    showConfirmModal({
      title: "Confirm Delete?",
      icon: null,
      content: "Are you sure you want to delete this?",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      className: "custom-modal",
      onOk() {
        handleDelete(id);
      },
    });
  };

  const filterUsers = (input, option) => {
    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await Promise.all([getServiceType(), getGroup()]);
      } catch (error) {
        Notification.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(()=>{
    getServices()
  },[])

  return (
    <div className="mx-auto">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-lg font-bold ">Service List</h1>
        <Button type="primary" onClick={openModal}>
          Add Service
        </Button>
      </div>
      <CustomTable
        columns={getServiceListColumns({ handleEdit, showDeleteConfirm, role })}
        dataSource={services}
        loading={loading}
        rowKey={"service_list"}
      />

      <Modal
        width={1000}
        title={editService ? "Edit Service" : "Add Service"}
        closeIcon={
          <Button size="small" className="app-close-icon" shape="round">
            Close
          </Button>
        }
        onCancel={handleCancel}
        open={isModal}
        footer={null}
      >
        <Form
          form={form}
          name="service-list"
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="service_name"
                label="Service Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter service name",
                  },
                  {
                    validator: validateServiceName,
                  },
                ]}
              >
                <AutoComplete
                  onSearch={handleSearchServices}
                  options={serviceTypeOptions}
                  placeholder="Search / Add Service"
                  maxLength={50}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="service_type" label="Type">
                <Select
                  showSearch
                  placeholder="Select Type"
                  filterOption={filterUsers}
                >
                  {serviceType &&
                    serviceType.map((item) => (
                      <Option key={item.id} value={item.service_type}>
                        {item.service_type}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="service_group" label="Group">
                <Select
                  showSearch
                  placeholder="Select Group"
                  filterOption={filterUsers}
                >
                  {group &&
                    group.map((item) => (
                      <Option key={item.id} value={item.group}>
                        {item.group}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="service_price"
                label="Price"
                rules={[
                  {
                    validator: validatePrice,
                  },
                ]}
              >
                <Input maxLength={15}/>
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button className="mr-2" onClick={handleCancel}>
              Cancel
            </Button>
            <BasicButton loading={submitLoading} saving={!editService} title={editService ? "Update" : "Save"}/>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ServiceList;
